module.exports = __webpack_public_path__ + "static/media/quindio-62.af89a0f2.jpg";